import React, { useEffect, createElement } from 'react';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  useEffect(() => {
    if (!document.querySelector('script[src="https://fast.wistia.com/player.js"]')) {
      const playerScript = document.createElement('script');
      playerScript.src = 'https://fast.wistia.com/player.js';
      playerScript.async = true;
      document.head.appendChild(playerScript);
    }
    if (!document.querySelector('script[src="https://fast.wistia.com/embed/gij9wut8ww.js"]')) {
      const embedScript = document.createElement('script');
      embedScript.src = 'https://fast.wistia.com/embed/gij9wut8ww.js';
      embedScript.async = true;
      embedScript.type = 'module';
      document.head.appendChild(embedScript);
    }
  }, []);
  const wistiaHtml = ['<style>{`', "wistia-player[media-id='gij9wut8ww']:not(:defined){", "background:center/contain no-repeat url('https://fast.wistia.com/embed/medias/gij9wut8ww/swatch');", 'display:block;filter:blur(5px);padding-top:56.25%}', '`}</style>', '<wistia-player media-id="gij9wut8ww" aspect="1.7777777777777777"></wistia-player>'].join('');
  return <section className="relative bg-[#1a0a2e] text-white min-h-screen flex flex-col items-center justify-center pt-20 pb-16 px-4 overflow-hidden" data-id="element-89">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#5B2D8E] rounded-full blur-[150px] opacity-30 pointer-events-none" data-id="element-90"></div>

      {/* Urgency Bar */}
      <div className="absolute top-0 left-0 w-full bg-[#5B2D8E] text-white text-center py-2 px-4 text-sm md:text-base font-medium z-10" data-id="element-91">
        🔥 Oferta Mes de la Mujer: 90% OFF · Valor $50 → Solo $5 · 100 cupos ·
        Termina el 15 de marzo
      </div>

      <div className="max-w-4xl mx-auto text-center z-10 flex flex-col items-center mt-8" data-id="element-92">
        <img src="https://cdn.magicpatterns.com/uploads/nXYpd4SR7Fr6Q5sxJGuDRZ/LOGO_TRILOGY_350_X_180_(1080_x_1080_px).png" alt="Trilogy Logo" className="h-24 md:h-32 mb-8 object-contain" data-id="element-93" />

        <h2 className="text-[#F5A623] font-bold tracking-widest text-sm md:text-base mb-4 uppercase" data-id="element-94">
          NOCHE DE IMPACTO
        </h2>

        <div className="w-full max-w-3xl mb-8 rounded-2xl overflow-hidden shadow-lg" data-id="element-95">
          <div dangerouslySetInnerHTML={{
          __html: wistiaHtml
        }} data-id="element-96" />
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold leading-tight mb-6" data-id="element-97">
          Rompe en Una Sola Noche
          <br className="hidden md:block" data-id="element-98" /> el Límite que Lleva Años
          <br className="hidden md:block" data-id="element-99" /> Deteniéndote
        </h1>

        <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-100">
          Un entrenamiento presencial, en español, donde vas a identificar,
          enfrentar y romper físicamente el bloqueo que más te ha frenado — con
          tus propias manos.
        </p>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-base md:text-lg font-medium mb-10 bg-white/5 py-4 px-6 rounded-2xl border border-white/10" data-id="element-101">
          <span className="flex items-center gap-2" data-id="element-102">📍 Miami, Florida</span>
          <span className="flex items-center gap-2" data-id="element-103">🗓️ 16 de Marzo</span>
          <span className="flex items-center gap-2" data-id="element-104">🕖 2.5 horas</span>
          <span className="flex items-center gap-2 text-[#F5A623]" data-id="element-105">
            💵 Solo $5
          </span>
        </div>

        <CTAButton className="mb-2" data-id="element-106">🔥 RESERVA TU LUGAR</CTAButton>
        <p className="text-sm md:text-base text-[#F5A623] font-medium mb-8" data-id="element-107">
          $50 → $5 · 90% OFF · Solo por el Mes de la Mujer
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 text-sm text-gray-400" data-id="element-108">
          <span className="flex items-center gap-1" data-id="element-109">✅ Pago 100% seguro</span>
          <span className="flex items-center gap-1" data-id="element-110">
            ✅ Confirmación inmediata
          </span>
          <span className="flex items-center gap-1" data-id="element-111">✅ Solo 100 cupos</span>
        </div>
      </div>
    </section>;
}